export default [
  {
    name: "name",
    htmlType: "text",
    dbType: "string",
    title: "Name",
    containerClass: "col-12 col-md-4",
    required: false,
  },
  {
    name: "lastName",
    htmlType: "text",
    dbType: "string",
    title: "Last Name",
    containerClass: "col-12 col-md-4",
    required: false,
  },
  {
    name: "secondLastName",
    htmlType: "text",
    dbType: "string",
    title: "Second Last Name",
    containerClass: "col-12 col-md-4",
    required: false,
  },
  // {
  //   name: "alias",
  //   htmlType: "text",
  //   dbType: "string",
  //   title: "Alias",
  //   containerClass: "col-12 col-md-4",
  //   required: false,
  // },
  {
    name: "tss",
    htmlType: "text",
    dbType: "string",
    title: "TSS",
    containerClass: "col-12 col-md-4",
    required: false,
  },
  {
    name: "identifier",
    htmlType: "text",
    dbType: "string",
    title: "Cédula",
    containerClass: "col-12 col-md-4",
    required: false,
  },
  {
    name: "passport",
    htmlType: "text",
    dbType: "string",
    title: "Passport",
    containerClass: "col-12 col-md-4",
    required: false,
  },
  {
    name: "ageFrom",
    htmlType: "number",
    dbType: "string",
    title: "Age From",
    containerClass: "col-12 col-md-4",
    required: false,
  },
  {
    name: "ageUntil",
    htmlType: "number",
    dbType: "string",
    title: "Age Until",
    containerClass: "col-12 col-md-4",
    required: false,
  },
  {
    name: "gender",
    htmlType: "select",
    dbType: "string",
    title: "Gender",
    containerClass: "col-12 col-md-4",
    required: false,
    dataSourceTextField: "name",
    dataSourceValueField: "id",
    dataSourceLocal: [
      { id: "M", name: "Masculino" },
      { id: "F", name: "Femenino" },
    ],
  },
]
